import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';
import { ICellEditorAngularComp } from 'ag-grid-angular';

@Component({
  selector: 'app-dropdown-cell-editor',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.sass']
})
export class DropdownEditorComponent implements ICellEditorAngularComp, AfterViewInit {
  @ViewChild(Dropdown, { static: true }) dropdown: Dropdown;

  public params: any;
  public value: any;
  public originalValue: any;

  public fieldName: string = '';
  public options: any[] = [];
  private optionsMap: { [key: string]: any } = {};
  public optionLabel: string = 'label';
  public optionValue: string = 'value';

  agInit(params: any): void {
    // Validate params exist early
    if (!params) {
      console.error('Dropdown editor: params is null or undefined');
      return;
    }
    
    this.params = params;
  
    console.log('Dropdown params:', this.params);
  
    // Validate options exist early
    if (!this.params.colDef?.filterParams?.values) {
      console.error('No options provided for dropdown');
      this.options = [];
      return;
    }
  
    // GETTING LABEL
    this.fieldName = this.params.colDef.headerName;
  
    // GETTING OPTIONS
    if (this.params.isFlatList && !this.params.isLinkDestination) {
      // Handle flat list options (e.g., ['Option1', 'Option2'])
      this.options = this.params.colDef.filterParams.values
        .filter((item: any) => item !== '(EMPTY)' && item !== '(NOT EMPTY)')
        .map((item: any) => ({ label: item, value: item }));
      
      this.optionLabel = 'label';
      this.optionValue = 'value';
      
      // Build optionsMap for flat lists
      this.options.forEach(option => {
        this.optionsMap[option.value] = option;
      });
    } else {
      // Handle object options (e.g., [{name: 'Option1', _id: 1}])
      this.options = this.params.colDef.filterParams.values;
      this.optionLabel = this.params.optionLabel;
      this.optionValue = this.params.optionValue;
      
      // Build optionsMap for object values
      if (this.params.objectValue && this.optionValue) {
        this.options.forEach(option => {
          this.optionsMap[option[this.optionValue]] = option;
        });
      }
    }
    
    console.log('Options:', this.options);
    console.log('Current value from cell:', this.params.value);
  
    // GETTING VALUE
    if (this.params.isFlatList && !this.params.isLinkDestination) {
      // For flat lists, value is a simple string
      this.value = this.params.value;
      this.originalValue = this.params.value;
    } else if (this.params.objectValue && this.params.optionValue) {
      // For object values, extract the property value
      this.value = this.params.value?.[this.params.optionValue];
      this.originalValue = this.params.value?.[this.params.optionValue];
    } else {
      // Default case
      this.value = this.params.value;
      this.originalValue = this.params.value;
    }
    
    console.log('Processed value for dropdown:', this.value);
  }
  

  ngAfterViewInit(): void {
    setTimeout(() => {
      if (this.dropdown) {
        this.dropdown.focus();
      }
    });
  }

  getValue(): any {
    if (this.params.isFlatList && !this.params.isLinkDestination) {
      // For flat lists, return the string value directly
      return this.value;
    } else if (this.params.objectValue && this.params.optionValue) {
      // For object values, return the full object
      return this.optionsMap[this.value] || null;
    } else {
      return this.value;
    }
  }

  isPopup(): boolean {
    return true;
  }

  clearValue(){
    this.value = null;
  }

  setOriginalValue(){
    this.value = this.originalValue;
  }
}
